import { morphSection } from '@theme/section-renderer';
import { fetchConfig } from '@theme/utilities';

document.addEventListener('ed:gift-add-to-cart', async (event) => {
    const { formData, sections, cartType } = event.detail;
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    
    try {
        const response = await fetch(`/cart/add.js`, config);
        const data = await response.json();
        
        if (data.sections) {
            Object.entries(data.sections).forEach(([sectionId, html]) => {
                morphSection(sectionId, html);
            });
        }
        
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: true, data }
        }));
        
    } catch (error) {
        console.error(error);
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: false, error }
        }));
    }
});

document.addEventListener('ed:gift-add-multiple-to-cart', async (event) => {
    const { items, sections } = event.detail;
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify({ 
        items: items,
        sections: sections,
        sections_url: window.location.pathname
    });
    
    try {
        const response = await fetch(`/cart/add.js`, config);
        const data = await response.json();
        
        if (data.sections) {
            Object.entries(data.sections).forEach(([sectionId, html]) => {
                morphSection(sectionId, html);
            });
        }
        
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: true, data }
        }));
        
    } catch (error) {
        console.error(error);
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: false, error }
        }));
    }
});

document.addEventListener('ed:gift-remove-from-cart', async (event) => {
    const { formData, sections, cartType } = event.detail;
    
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    
    try {
        const response = await fetch(`/cart/change.js`, config);
        const data = await response.json();
        
        if (data.sections) {
            Object.entries(data.sections).forEach(([sectionId, html]) => {
                morphSection(sectionId, html);
            });
        }
        
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: true, data }
        }));
        
    } catch (error) {
        console.error(error);
        document.dispatchEvent(new CustomEvent('ed:gift-cart-updated', {
            detail: { success: false, error }
        }));
    }
});